import React from 'react'
import './loadingComponent.css'
import logoSuperior from '../../../assets/img/LOGO-Superior-blanco.png'

export const LoadingComponent = () => {
    return (
        <div className='logo-loading-container'>

            <img className='logo-loading' src={logoSuperior} alt="Cargando..." />

        </div>
    )
}
